import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { PoliciesResponse, PromotionRes } from '../model/http/myActivity.model';
import { ConsumeService } from './consume.service';
import { PromotionResMock } from 'src/mocks/promotionsMock';

@Injectable({
  providedIn: 'root'
})
export class PromotionsService {

  constructor(private consumeService: ConsumeService) { }
  getPromotions(queryParams: string): Observable<PromotionRes> {
    return this.consumeService.httpGet<PromotionRes>(`${Endpoints.promotions}${queryParams}`);
  }

  getPendingPromotions(queryParams: string): Observable<PromotionRes> {
    return this.consumeService.httpGet<PromotionRes>(`${Endpoints.promotions}/pending${queryParams}`);
  }

  getPolicies(): Observable<PoliciesResponse> {
    return this.consumeService.httpGet<PoliciesResponse>(Endpoints.policies);
  }
}
